define('OutSystems/ReactView/Router',["require", "exports", "tslib", "OutSystems/ClientRuntime/ApplicationInfo", "OutSystems/ClientRuntime/EventDispatcher", "OutSystems/ClientRuntime/Logger", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/Navigation", "OutSystems/ClientRuntime/Performance", "OutSystems/ClientRuntime/StorageProvider", "react", "react-dom", "react-router-dom", "./BaseNavigationCallbacks", "./createHistory", "./ErrorBoundary", "./LazyScreen", "./LocationUtils", "./Root", "./RouteComponents", "./ScreenLoader"], function (require, exports, tslib_1, ApplicationInfo, EventDispatcher_1, Logger, Navigation_1, Navigation, OSPerformance, StorageProvider_1, React, ReactDOM, react_router_dom_1, BaseNavigationCallbacks_1, createHistory_1, ErrorBoundary_1, LazyScreen_1, LocationUtils_1, Root_1, RouteComponents_1, ScreenLoader_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getRouteInfos = exports.load = exports.createApplicationRoutes = exports.createLazyScreenRoute = exports.createScreenRoute = void 0;
    var ROUTER_MODULE_NAME = "Router";
    var SCREEN_ROUTE_KEY = "screen-route-key";
    var MODULE_ROUTE_KEY = "module-route-key";
    var createScreenRouteKey = function (screenName, forDefaultPath) {
        if (forDefaultPath === void 0) { forDefaultPath = false; }
        return "" + SCREEN_ROUTE_KEY + (forDefaultPath ? "-default-" : "-") + screenName;
    };
    var createScreenRoute = function (_a, location) {
        var pathname = _a.pathname, forDefaultPath = _a.forDefaultPath, screenName = _a.screenName, component = _a.component;
        return (React.createElement(react_router_dom_1.Route, { path: pathname, exact: true, key: createScreenRouteKey(screenName, forDefaultPath), location: location, component: component }));
    };
    exports.createScreenRoute = createScreenRoute;
    var createLazyScreenRoute = function (_a, screenLoader, location, onEnter, onLeave) {
        var screenName = _a.screenName, forDefaultPath = _a.forDefaultPath, pathname = _a.pathname;
        return (React.createElement(react_router_dom_1.Route, { key: createScreenRouteKey(screenName, forDefaultPath), exact: true, path: pathname, location: location, render: function (props) {
                var component = screenLoader.getLoadedComponent(props.location.key);
                return (React.createElement(LazyScreen_1.default, tslib_1.__assign({ onEnter: onEnter, onLeave: function () {
                        screenLoader.freeLoadedComponent(props.location.key);
                        if (onLeave) {
                            onLeave();
                        }
                    }, component: component }, props)));
            } }));
    };
    exports.createLazyScreenRoute = createLazyScreenRoute;
    var createApplicationRoutes = function (routeInfos, screenLoader, location) {
        return routeInfos.map(function (routeInfo) {
            return routeInfo.component
                ? exports.createScreenRoute(routeInfo, location)
                : exports.createLazyScreenRoute(routeInfo, screenLoader, location);
        });
    };
    exports.createApplicationRoutes = createApplicationRoutes;
    var routerStorage = {
        currentAge: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Session, "RouterHistoryAge", 0),
    };
    function onBeforeNavigate(runtime, nextLocation, action) {
        var _a, _b, _c;
        var currentAge = routerStorage.currentAge.get();
        var nextLocationAge = LocationUtils_1.calculateNextLocationAge((_b = (_a = nextLocation.state) === null || _a === void 0 ? void 0 : _a.age) !== null && _b !== void 0 ? _b : 0, nextLocation.hash, action, currentAge);
        nextLocation.state = tslib_1.__assign(tslib_1.__assign({}, ((_c = nextLocation.state) !== null && _c !== void 0 ? _c : {})), { age: nextLocationAge });
        var backNavigation = LocationUtils_1.isBackNavigation(nextLocation.state.age, action, currentAge);
        var proceedWithNavigation = Root_1.default.onBeforeNavigation(runtime, tslib_1.__assign(tslib_1.__assign({}, nextLocation), { action: action }), backNavigation);
        if (proceedWithNavigation) {
            if (backNavigation && !nextLocation.key) {
                Navigation_1.navigateBack(null);
                return runtime.exit();
            }
            routerStorage.currentAge.set(nextLocation.state.age);
            EventDispatcher_1.EventDispatcher.dispatch({ type: EventDispatcher_1.EventType.NavigationStart, args: nextLocation });
            return true;
        }
        return false;
    }
    function load(runtime, callback, historyFactory) {
        Logger.trace(ROUTER_MODULE_NAME, "Loading Router.");
        var callbackWithPerformanceCollection = function () {
            OSPerformance.end("Router load triggered render");
            if (typeof callback === "function") {
                callback();
            }
        };
        var homeModule = ApplicationInfo.getHomeModuleDefinition();
        var splashScreen = ApplicationInfo.getScreenDefinitionFromScreenName(homeModule, homeModule.splashScreenName);
        var splashRouteInfo;
        if (splashScreen) {
            splashRouteInfo = {
                pathname: "*",
                forDefaultPath: false,
                screenName: splashScreen.screenName,
                lazyComponentInfo: makeLazyComponentInfo(false, splashScreen),
            };
        }
        var screenRouteInfos = exports.getRouteInfos();
        var screenLoader = new ScreenLoader_1.default(runtime, screenRouteInfos, splashRouteInfo);
        var browserHistory = createHistory_1.default(function (_, nextLocation, action) { return onBeforeNavigate(runtime, nextLocation, action); }, screenLoader, historyFactory);
        Navigation.setNavigationCallbacks(new BaseNavigationCallbacks_1.default(browserHistory, runtime));
        var onError = function (error) {
            runtime.handleError(error);
        };
        ReactDOM.render(React.createElement(ErrorBoundary_1.default, { onError: onError },
            React.createElement(react_router_dom_1.Router, { history: browserHistory },
                React.createElement(react_router_dom_1.Route, { key: MODULE_ROUTE_KEY + "-" + homeModule.moduleName, render: function (props) {
                        var screenRoutes = runtime.shouldRenderSplashScreen() && splashScreen
                            ? [
                                exports.createLazyScreenRoute(splashRouteInfo, screenLoader, props.location, function () { return (runtime.isShowingSplashScreen = true); }, function () { return (runtime.isShowingSplashScreen = false); }),
                            ]
                            : exports.createApplicationRoutes(screenRouteInfos, screenLoader, props.location);
                        return (React.createElement(react_router_dom_1.Route, { path: "/", key: SCREEN_ROUTE_KEY, location: props.location, render: function (props) { return (React.createElement(Root_1.default, tslib_1.__assign({ runtime: runtime, screenLoader: screenLoader, location: props.location }, props),
                                React.createElement(react_router_dom_1.Switch, { location: props.location },
                                    screenRoutes,
                                    React.createElement(react_router_dom_1.Route, { key: "not-found-screen", location: props.location, component: RouteComponents_1.NotFoundScreen })))); } }));
                    } }))), document.getElementById("reactContainer"), callbackWithPerformanceCollection);
    }
    exports.load = load;
    var makeLazyComponentInfo = function (shallSaveStateOnLeave, screen) { return ({
        shallSaveStateOnLeave: shallSaveStateOnLeave,
        viewModuleName: screen.viewModuleName,
        modelModuleName: screen.modelModuleName,
        controllerModuleName: screen.controllerModuleName,
        webFlowControllerModuleName: screen.webFlowControllerModuleName,
    }); };
    var getRouteInfos = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.getModules, getModules = _c === void 0 ? ApplicationInfo.getModules : _c, _d = _b.getHomeModuleDefinition, getHomeModuleDefinition = _d === void 0 ? ApplicationInfo.getHomeModuleDefinition : _d, _e = _b.getBasePath, getBasePath = _e === void 0 ? ApplicationInfo.getBasePath : _e;
        Logger.trace(ROUTER_MODULE_NAME, "Creating application routes.");
        var routeInfo = [];
        var modules = getModules();
        var basePath = getBasePath().replace(/\/$/, "");
        for (var moduleKey in modules) {
            if (modules.hasOwnProperty(moduleKey)) {
                var module = modules[moduleKey];
                if (module === getHomeModuleDefinition()) {
                    if (module === getHomeModuleDefinition()) {
                        var moduleHomeScreen = module.homeScreenName
                            ? ApplicationInfo.getScreenDefinitionFromScreenName(module, module.homeScreenName)
                            : undefined;
                        var moduleDefaultRoute = moduleHomeScreen
                            ? {
                                pathname: basePath,
                                forDefaultPath: true,
                                screenName: moduleHomeScreen.screenName,
                                lazyComponentInfo: makeLazyComponentInfo(true, moduleHomeScreen),
                            }
                            : {
                                pathname: basePath,
                                forDefaultPath: true,
                                screenName: "no-default-screen",
                                component: RouteComponents_1.NoDefaultScreen,
                            };
                        routeInfo.push(moduleDefaultRoute);
                        Logger.trace(ROUTER_MODULE_NAME, "Created default application route for " + moduleDefaultRoute.pathname);
                    }
                    routeInfo.push.apply(routeInfo, module.screens.map(function (screen) { return ({
                        pathname: basePath + "/" + screen.screenUrl,
                        forDefaultPath: false,
                        screenName: screen.screenName,
                        lazyComponentInfo: makeLazyComponentInfo(true, screen),
                    }); }));
                }
            }
        }
        return routeInfo;
    };
    exports.getRouteInfos = getRouteInfos;
});
//# sourceMappingURL=Router.js.map;
